module.exports = __webpack_public_path__ + "static/media/venom-punch.e57c2626.png";